import * as z from "zod";
import { hsaSessionState } from "./types";

// Read-only view navigation: returns the step preceding the client's current
// one on the active path. Never mutates answers; edits go via submitHsaAnswer.
export const rewindHsaGroupInput = z.object({
  sessionToken: z.string().uuid(),
  currentStepHandle: z.string().min(1),
});

export const rewindHsaGroupOutput = z.object({ state: hsaSessionState });
